module.exports = __webpack_public_path__ + "img/8.abc244bc.jpg";